<div class="pagetitle">
  <h2>List Partners</h2>
  <a [routerLink]="['/dashboard/partner/new']" class="btn btn-sm btn-outline-success"><i class="fa fa-fw fa-plus"></i>
Create new partner</a>
</div>

<alert></alert>

<div class="search-form form-row form-group">
  <div class="col-md-1">
    <select class="form-control form-control-sm" [(ngModel)]="pagination.limit.value" (ngModelChange)="pagination.limit.valueChanges.next($event)">
      @for (option of pagination.config.limitOptions; track option) {
        <option value="{{option.key}}">{{option.value}}</option>
      }
    </select>
  </div>
  <div class="col-md-4 float-right">
    <div class="input-wrapper">
      <input type="text" class="form-control form-control-sm" placeholder="Partner name" [(ngModel)]="nameSearch.value" (ngModelChange)="nameSearch.valueChanges.next($event)" />
      <i class="fa fa-fw fa-search"></i>
    </div>
  </div>
</div>

<div class="table-responsive">
  <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th width="200" [index]="0" [resizeColumn]="true" (click)="sort(sortMethodTypes.PARTNER_NAME)"
                    [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.PARTNER_NAME, 
                    'fa-sort-asc': (sortMethod === sortMethodTypes.PARTNER_NAME && sortDirection === 'ASC'), 
                    'fa-sort-desc': (sortMethod === sortMethodTypes.PARTNER_NAME && sortDirection === 'DESC') }">
          Partner Name
        </th>

                <th width="" [index]="1" [resizeColumn]="true" (click)="sort(sortMethodTypes.EMAIL)" [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.EMAIL, 
                    'fa-sort-asc': (sortMethod === sortMethodTypes.EMAIL && sortDirection === 'ASC'), 
                    'fa-sort-desc': (sortMethod === sortMethodTypes.EMAIL && sortDirection === 'DESC') }">
          Email
        </th>

        <th width="70" [index]="2" [resizeColumn]="true" class="text-center sort-na">Status</th>

        <th width="130" [index]="3" [resizeColumn]="true" class="sort-na">Phone</th>

                <th width="100" [index]="4" [resizeColumn]="true" (click)="sort(sortMethodTypes.COUNTRY)" [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.COUNTRY, 
                    'fa-sort-asc': (sortMethod === sortMethodTypes.COUNTRY && sortDirection === 'ASC'), 
                    'fa-sort-desc': (sortMethod === sortMethodTypes.COUNTRY && sortDirection === 'DESC') }">
          Country
        </th>

        <th width="250" [index]="5" [resizeColumn]="true" class="sort-na">Action</th>
      </tr>
    </thead>
    <tbody>

      @if ((!partners && loading) || (partners && partners.length === 0)) {
        <tr>
          <td colspan="7" class="loading text-center">
            <span class="">{{msg}}</span>
          </td>
        </tr>
      }
      @for (partner of partners | paginate: {
        itemsPerPage: pagination.limit.value,
        currentPage: pagination.page,
        totalItems: pagination.totalRecords
        }; track partner) {
        <tr data-id="{{partner.id}}">
          <td><a [routerLink]="['/dashboard/partner/view/', partner.id]" [state]="{ data: { partner: partner }}">{{partner.name}}</a></td>
          <td>{{partner.email}}</td>
          <td class="text-center">
            @if (partner.status=='active') {
              <span class="badge badge-success">{{partner.status}}</span>
            }
            @if (partner.status=='inactive') {
              <span class="badge badge-secondary">{{partner.status}}</span>
            }
          </td>
          <td>{{partner.phone}}</td>
          <td class="ellepsis" title="{{partner.country}}">{{partner.country}}</td>
          <td class="text-center">
            <a class="btn btn-assign btn-xs" href="javascript:;" title="View UUID" placement="left"
              ngbPopover="{{partner.id}}" [autoClose]="'outside'" popoverTitle="Partner UUID"><i
            class="fa fa-fw fa-eye"></i> UUID</a> &nbsp;
            <a class="btn btn-edit btn-xs" [routerLink]="['/dashboard/partner/edit/',(partner.id)]"
              [state]="{ data: { view: 'edit', partner: partner }}" title="Edit Partner"><i
            class="fa fa-fw fa-edit"></i> Edit</a> &nbsp;
            <a class="btn btn-primary btn-xs" [style.color]="'white'" [routerLink]="['/dashboard/partner/' + (partner.id) + '/scheme']"
              [state]="{ data: { partner: partner }}" title="Edit Partner Colors"><i
            class="fas fa-fw fa-palette"></i> Colors</a> &nbsp;
            <a class="btn btn-delete btn-xs" href="javascript:;" (click)="deletePartner(partner)"
              title="Delete Partner"><i class="fa fa-fw fa-trash"></i> Delete</a>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <!-- Pagination Interface -->
    @if (pagination.totalRecords && pagination.totalRecords > pagination.limit.value) {
      <div class="pagination-layout">
        @if (pagination) {
          <pagination-controls maxSize="7" (pageChange)="pagination.page = $event"></pagination-controls>
        }
      </div>
    }
  </div>